const COUNTRY_ALIASES = {
  bahamas: 'the_bahamas',
  'the bahamas': 'the_bahamas',
  'trinidad & tobago': 'trinidad_and_tobago',
  'trinidad and tobago': 'trinidad_and_tobago',
}

export const normalizeCountryName = (country) => {
  const normalized = String(country || '').trim().toLowerCase()
  return COUNTRY_ALIASES[normalized] || normalized
}

export const countriesMatch = (left, right) => {
  return normalizeCountryName(left) === normalizeCountryName(right)
}

export const includesCountry = (countries, targetCountry) => {
  return (countries || []).some(country => countriesMatch(country, targetCountry))
}
